module.exports = __webpack_public_path__ + "assets/War-white.3c4265c0.svg";